import { render, staticRenderFns } from "./ForumRules.vue?vue&type=template&id=b4d06748&scoped=true&"
import script from "./ForumRules.vue?vue&type=script&lang=js&"
export * from "./ForumRules.vue?vue&type=script&lang=js&"
import style0 from "./ForumRules.vue?vue&type=style&index=0&id=b4d06748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d06748",
  null
  
)

export default component.exports